import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { JsonHttpService } from 'src/app/shared/http/json-http.service';

@Injectable({
  providedIn: 'root'
})
export class TenantService {
  private http = inject(JsonHttpService);

  getTenantShortName(): Promise<string> {
    return firstValueFrom(this.http.getTyped<string>('/api/tenant/get-tenant-shortName'));
  }

  getTenantLongName(): Promise<string> {
    return firstValueFrom(this.http.getTyped<string>('/api/tenant/get-tenant-longName'));
  }

  setTenantLongName(longName: string): Promise<string> {
    return firstValueFrom(this.http.postTyped<string>('/api/tenant/set-tenant-longName', JSON.stringify(longName)));
  }
}
